import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ClientsComponent } from "./pages/clients/clients.component";
import { ClientFormComponent } from "./pages/clients/components/client-form/client-form.component";
import { StatusConfigComponent } from "./pages/status-config/status-config.component";
import { EventListComponent } from "./pages/events/event-list/event-list.component";
import { SettingProjectsComponent } from "./pages/projects/pages/setting/setting-projects/setting-projects.component";
import { DocumentTemplatesComponent } from "./pages/projects/pages/setting/setting-projects/pages/document-templates/document-templates.component";
import { BudgetParameterComponent } from "./pages/projects/pages/setting/setting-projects/pages/budget-parameter/budget-parameter.component";
import { BudgetParameterRegisterComponent } from "./pages/projects/pages/setting/setting-projects/pages/budget-parameter-register/budget-parameter-register.component";
import { BudgetParameterEditComponent } from "./pages/projects/pages/setting/setting-projects/pages/budget-parameter-edit/budget-parameter-edit.component";
import { BudgetItemListComponent } from "./pages/projects/pages/budget-item/budget-item-list/budget-item-list.component";
import { BudgetViewComponent } from "./pages/projects/pages/documents/budget-view/budget-view.component";
import { EditarPropostaComercialComponent } from "./pages/projects/pages/documents/proposta-comercial/editar-proposta-comercial/editar-proposta-comercial.component";
import { EditarContratoComponent } from "./pages/projects/pages/documents/contrato/editar-contrato/editar-contrato.component";
import { DocumentoAssinaturaComponent } from "./pages/projects/pages/documents/contrato/documento-assinatura/documento-assinatura.component";
import { WhatsappAttendanceComponent } from "./pages/whatsapp/pages/whatsapp-attendance/whatsapp-attendance.component";
import { WhatsappConfigComponent } from "./pages/whatsapp/pages/whatsapp-config/whatsapp-config.component";
import { ChatDashboardComponent } from "./pages/whatsapp/pages/chat-dashboard/chat-dashboard.component";
import { ProjetoListComponent } from "./pages/projects/pages/projeto-list/projeto-list.component";
import { OrcamentoListComponent } from "./pages/projects/pages/orcamento-list/orcamento-list.component";
import { DashboardCallCenterComponent } from "./pages/dashboard/dashboard-call-center.component";

const routes: Routes = [
  {
    path: "clientes",
    component: ClientsComponent,
  },
  {
    path: "clientes/novo",
    component: ClientFormComponent,
  },
  {
    path: "clientes/:id",
    component: ClientFormComponent,
  },
  {
    path: "configuracoes",
    component: StatusConfigComponent,
  },
  {
    path: "contatos",
    loadChildren: () =>
      import("./pages/contacts/contacts-routing.module").then(
        (m) => m.ContactsRoutingModule,
      ),
  },
  {
    path: "feiras",
    component: EventListComponent,
  },
  {
    path: "projetos",
    component: ProjetoListComponent
  },
  {
    path: "projetos/configuracoes",
    component: SettingProjectsComponent
  },
  {
    path: "projetos/configuracoes/templates",
    component: DocumentTemplatesComponent
  },
  {
    path: "projetos/configuracoes/parametros-orcamento",
    component: BudgetParameterComponent
  },
  {
    path: "projetos/configuracoes/parametros-orcamento/novo",
    component: BudgetParameterRegisterComponent
  },
  {
    path: "projetos/configuracoes/parametros-orcamento/:id",
    component: BudgetParameterEditComponent
  },
  {
    path: "projetos/itens-orcamento",
    component: BudgetItemListComponent
  },
  {
    path: "projetos/orcamentos",
    component: OrcamentoListComponent
  },
  {
    path: "projetos/orcamento/novo",
    component: BudgetViewComponent
  },
  {
    path: "projetos/orcamento/:id",
    component: BudgetViewComponent
  },
  {
    path: "projetos/contrato/:id",
    component: EditarContratoComponent
  },
  {
    path: "projetos/proposta-comercial/:id",
    component: EditarPropostaComercialComponent
  },
  {
    path: "projetos/documentos-assinatura",
    component: DocumentoAssinaturaComponent
  },
  {
    path: "atendimento-whatsapp",
    component: WhatsappAttendanceComponent
  },
  {
    path: "configuracao-whatsapp",
    component: WhatsappConfigComponent
  },
  {
    path: "chat/dashboard",
    component: ChatDashboardComponent
  },
  {
    path: "chat/conversas",
    component: WhatsappAttendanceComponent
  },
  {
    path: "chat/atendentes",
    loadChildren: () =>
      import("./pages/whatsapp/pages/atendentes/atendentes.module").then(
        (m) => m.AtendentesModule
      )
  },
  {
    path: "chat/configuracoes",
    component: WhatsappConfigComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CallCenterRoutingModule {}
